export const getVersion = () => process.env.REACT_APP_VERSION;
